import React from 'react';

import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as NavLink } from 'react-router';

import {
  AuthWrapperStyled,
  ButtonBlueStyled,
  ButtonWhiteStyled,
  InfoTextStyled,
  SectionContentStyled,
  SectionContentWrapperStyled,
  SectionStyled,
  SectionSubTitleStyled,
  SectionTitleStyled,
  SectionWhiteStyled,
} from './styles';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import Logo from '../../components/Logo';

const Auth = React.memo(() => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ p: 2.5 }}>
      <AuthWrapperStyled direction="row" width="100%">
        <SectionStyled>
          <Logo />

          <SectionContentWrapperStyled>
            <SectionContentStyled spacing={1}>
              <SectionTitleStyled sx={(theme) => ({ color: theme.palette.neutral[100] })}>
                {t('auth.signin.title')}
              </SectionTitleStyled>

              <SectionSubTitleStyled
                sx={(theme) => ({
                  color: theme.palette.neutral[100],
                })}
              >
                {t('auth.signin.subtitle')}
              </SectionSubTitleStyled>

              <InfoTextStyled>{t('auth.signin.description')}</InfoTextStyled>
            </SectionContentStyled>
          </SectionContentWrapperStyled>

          <Stack direction="row" justifyContent="center">
            <ButtonWhiteStyled component={NavLink} to="/auth/signin" variant="contained">
              {t('auth.signin.button')}
            </ButtonWhiteStyled>
          </Stack>
        </SectionStyled>

        <SectionWhiteStyled>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Logo />
            <LanguageSwitcher />
          </Stack>

          <SectionContentWrapperStyled>
            <SectionContentStyled spacing={1}>
              <SectionTitleStyled>{t('auth.signup.title')}</SectionTitleStyled>
              <SectionSubTitleStyled>{t('auth.signup.subtitle')}</SectionSubTitleStyled>

              <InfoTextStyled sx={(theme) => ({ color: theme.palette.secondary[900] })}>
                {t('auth.signup.description')}
              </InfoTextStyled>
            </SectionContentStyled>
          </SectionContentWrapperStyled>

          <Stack direction="row" justifyContent="center">
            <ButtonBlueStyled component={NavLink} to="/auth/signup" variant="contained">
              {t('auth.signup.button')}
            </ButtonBlueStyled>
          </Stack>
        </SectionWhiteStyled>
      </AuthWrapperStyled>
    </Stack>
  );
});

export default Auth;
